import { Box, Checkbox, SxProps } from "@mui/material";
import { useStore } from "@priolo/jon";
import SuspenseMsgCmp from "components/layout/SuspenseMsgCmp";
import DatePlaceholder from "pages/farms/alert/list/date/DatePlaceholder";
import React, { FunctionComponent, useEffect, useMemo } from "react";
import draftSo from "stores/draft";
import querySo from "stores/route/query";
import { URL_PAR } from 'stores/route/utils/types';
import taskSo from "stores/task";
import { TasksScoreByDate } from "stores/task/utils/group";
import { Cycle } from "types/Cycle";
import { Task } from "types/Task";
import { Uuid } from "types/global";
import { dateToString } from "utils";
import TasksByDateCard from "./TasksByDateCard";



interface Props {
	groups?: TasksScoreByDate[]
	cycleUuidHighlight?: Uuid
	onClickTask?: (task: Task) => void
	onCycleMouseOver?: (cycle: Cycle, e: React.MouseEvent) => void
}
const TasksList: FunctionComponent<Props> = ({
	groups,
	cycleUuidHighlight,
	onClickTask,
	onCycleMouseOver,
}) => {

	// STORE
	const taskSa = useStore(taskSo)
	useStore(querySo)
	useStore(draftSo)

	// HOOKs
	useEffect(() => {
		const dateSelStr = querySo.getSearchUrl(URL_PAR.DATE_SEL)
		const elm = document.getElementById(dateSelStr)
		elm?.scrollIntoView({ behavior: "auto" /*"smooth"*/, block: "start" })
	}, [querySo.state])

	// RENDER
	if (!groups) return <SuspenseMsgCmp />

	// Calcolo tutti i task della lista e stato di selezione
	const allTasks = useMemo(() => {
		return groups.reduce((acc, group) => acc.concat(group.tasks), [] as Task[])
	}, [groups])

	const isAllTasksSelected = useMemo(() => {
		return allTasks.length > 0 && allTasks.every(task => taskSo.isSelected(task.taskUuid))
	}, [allTasks, taskSa.selecteds])

	// HANDLERs
	const handleToggleAllTasks = (e: React.MouseEvent) => {
		e.stopPropagation()
		if (isAllTasksSelected) {
			// Deseleziona tutti i task
			taskSo.setSelected([])
		} else {
			// Seleziona tutti i task della lista
			const allTaskUuids = allTasks.map(task => task.taskUuid)
			taskSo.setSelected(allTaskUuids)
		}
	}

	let date: number
	const inEdit = draftSo.isEditable()

	return (<>
		{/* Checkbox master per selezionare/deselezionare tutti i task */}
		{inEdit && allTasks.length > 0 && (
			<Box sx={sxSelectAll}>
				<Checkbox
					checked={isAllTasksSelected}
					indeterminate={!isAllTasksSelected && taskSa.selecteds.length > 0}
					onClick={handleToggleAllTasks}
					sx={{ p: 0, mr: 1 }}
				/>
				SELECT ALL TASKS ({allTasks.length})
			</Box>
		)}

		{groups.map((group) => {
			let prevDate = date
			date = group.date
			return <React.Fragment key={date}>
				<DatePlaceholder key="placeholder" prevDate={prevDate} currDate={date} desc />
				<TasksByDateCard key={date} id={dateToString(date)}
					group={group}
					onClick={onClickTask}
					editMode={inEdit}
					cycleUuidHighlight={cycleUuidHighlight}
					onCycleMouseOver={onCycleMouseOver}
				/>
			</React.Fragment>
		})}
		<DatePlaceholder prevDate={date} desc />
	</>
	)
}

export default TasksList


const sxSelectAll: SxProps = {
	display: "flex",
	alignItems: "center",
	mb: 2, ml: "23px", fontSize: "14px",
	fontWeight: 500,
	color: "text.secondary"
}
